import React from 'react';
import {FormattedMessage} from "react-intl";

import {ResidenceType} from "features/search/filters/enums";
import {capitalizeFirstLetter} from "features/services/utils/helpers";
import {getFormattedMessage} from "features/services/utils/language-helper";
import {useResidenceExplorerStore, selectCurrentView, selectSetup} from "features/residenceExplorer/store/useResidenceExplorerStore";

import './_residenceExplorerHeader.scss';

import {P} from "@atoms/Text/P";
import {SiteSpecificContent} from "@atoms/SiteSpecificContent";
import {
    ResidenceExplorerHeaderControls
} from "features/residenceExplorer/components/ResidenceExplorerV2/_residenceExplorerHeaderControls";
import {ResidenceExplorerPageType} from "features/residenceExplorer/types";
import {Headline} from '@atoms/Text/Headline';
import { HeadlineLevel, Margin } from 'features/ui/enums';

export const ResidenceExplorerHeader: React.FC = () => {
    const currentView = useResidenceExplorerStore(selectCurrentView);
    const settings = useResidenceExplorerStore(selectSetup);

    if (!settings) return null;

    const getTitle = () => {
        const { pageType, constructionForm, stageName } = settings;

        if (pageType === ResidenceExplorerPageType.AREA) {
            return stageName;
        }

        if (pageType === ResidenceExplorerPageType.STAGE) {
            return constructionForm === ResidenceType.PLOT ?
                getFormattedMessage("jm.components.ResidenceExplorer.titlePlot") :
                getFormattedMessage("jm.components.ResidenceExplorer.title");
        }

        const projectName = capitalizeFirstLetter(stageName);
        return constructionForm === ResidenceType.PLOT ?
            getFormattedMessage("jm.components.ResidenceExplorer.titleWithProjectPlot", { projectName }) :
            getFormattedMessage("jm.components.ResidenceExplorer.titleWithProject", { projectName });
    };

    return (
        <div className="residence-explorer-header">
            <Headline level={HeadlineLevel.H2} tabable>{getTitle()}</Headline>
            <SiteSpecificContent notFinland>
                {(currentView !== null && currentView !== undefined) && (
                    <P margin={Margin.M}>
                        <FormattedMessage id="jm.components.ResidenceExplorer.compareResidences" />
                    </P>
                )}
            </SiteSpecificContent>

            <ResidenceExplorerHeaderControls />
        </div>
    );
};
